<template>
  <div class="login">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
    >
      <h3 class="title">唐山城发集中采购平台</h3>
      <el-form-item prop="username">
        <el-input
          v-model="loginForm.username"
          type="text"
          auto-complete="off"
          placeholder="账号"
        >
          <el-icon slot="prefix" class="el-input__icon el-icon-s-custom" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        >
          <el-icon slot="prefix" class="el-input__icon el-icon-lock" />
        </el-input>
      </el-form-item>

      <el-checkbox
        v-model="loginForm.rememberMe"
        style="margin: 0px 0px 25px 0px"
        >记住密码</el-checkbox
      >
      <el-form-item style="width: 100%">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="width: 100%"
          @click.native.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
        <div style="float: right" v-if="register">
          <router-link class="link-type" :to="'/register'"
            >立即注册</router-link
          >
        </div>
      </el-form-item>
      <div id="captcha-box"></div>
    </el-form>
    <!--  底部  -->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { encrypt, decrypt } from "@/utils/jsencrypt";
import { login, getInfo, getCodeImg } from "@/api/home";
import "@/assets/captcha/css/tac.css"; // 验证码css
import "@/assets/captcha/js/jquery.min.js"; // 验证码js
import "@/assets/captcha/js/tac.min.js"; // 验证码js
import { setToken, setUserInfo } from "@/utils/auth";

export default {
  name: "Login",
  data() {
    return {
      captType: "slider",
      codeUrl: "",
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "",
        uuid: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      loading: false,
      // 验证码开关
      captchaEnabled: true,
      // 注册开关
      register: false,
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    if (this.$route.query && this.$route.query.tk) {
      this.$store.dispatch("Login1", this.$route.query.tk).then((res) => {
        switch (res.data.type) {
          case "1":
            this.$router
              .push({
                path: "/purchase_notice/noticeSh",
                query: { id: res.data.noticeId },
              })
              .catch(() => {});
            break;
          case "2":
            this.$router
              .push({
                path: "/purchase_notice/noticeShLeader",
                query: { id: res.data.noticeId },
              })
              .catch(() => {});
            break;
          case "3":
            this.$router
              .push({
                path: "/purchase_notice/noticeShBuy",
                query: { id: res.data.noticeId },
              })
              .catch(() => {});
        }

        // this.$router.push({ path: this.redirect || "/" }).catch(() => {});
      });
    }
    this.getCode();
    this.getCookie();
  },
  methods: {
    getCode() {
      getCodeImg().then((res) => {
        this.captchaEnabled =
          res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.loginForm.uuid = res.uuid;
        }
      });
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get("rememberMe");
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password:
          password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe),
      };
    },

    login() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.loginForm.rememberMe) {
            Cookies.set("username", this.loginForm.username, { expires: 30 });
            Cookies.set("password", encrypt(this.loginForm.password), {
              expires: 30,
            });
            Cookies.set("rememberMe", this.loginForm.rememberMe, {
              expires: 30,
            });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove("rememberMe");
          }
          const username = this.loginForm.username.trim();
          const password = this.loginForm.password;
          const code = this.loginForm.code;
          const uuid = this.loginForm.uuid;
          const token = this.loginForm.token;
          login(username, password, code, uuid, token)
            .then((res) => {
              this.$store.commit("token", res.token);
              setToken(res.token);
              getInfo().then((res) => {
                setUserInfo(JSON.stringify(res.user));
                this.$store.commit("userInfo", res.user);
                this.loading = false;
                this.$emit("success");
              });
            })
            .catch((error) => {
              this.loading = false;
              if (this.captchaEnabled && this.captType == "origin") {
                this.getCode();
              }
            });
        }
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        this.loginForm.uuid = "";
        this.loginForm.code = "";
        if (valid) {
          const config = {
            requestCaptchaDataUrl: "/dev-api/gen",
            validCaptchaUrl: "/dev-api/check",
            bindEl: "#captcha-box",
            // 验证成功回调函数
            validSuccess: (res, c, tac) => {
              this.loginForm.token = res.data.token || "";
              this.login();
              tac.destroyWindow();
            },
          };
          new window.TAC(config, { logoUrl: null }).init();
        }
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #be8737;
  font-weight: 700;
  font-size: 32px;
}

.login-form {
  border-radius: 6px;
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
  #captcha-box {
    position: absolute;
    top: calc(10%);
    left: calc(20%);
  }
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.login-code-img {
  height: 38px;
}
#tianai-captcha-parent .slider-bottom .logo {
  display: none;
}
</style>
